<template>
  <form>
    <b-field class="field-section" grouped>
      <b-field label="Rate"  expanded>
        <b-input v-model.number="rate" icon="dollar-sign"/>
      </b-field>

      <b-field label="Transaction ID"  expanded>
        <b-input :disabled="true" v-model="companyJobId" />
      </b-field>
    </b-field>

    <b-field label="Document Upload" class="field-section">
      <document-uploader :companyJobKey="companyJobKey" v-model="documents" @documentAdded="updateAttachedList" />
    </b-field>

    <b-field  class="field-section" grouped>
      <b-field label="Currently attached documents" expanded>
        <div class="attached-documents">
          <document-library :company-job-key="companyJobKey" :show-updated="false" ref="attachedDocuments" />
        </div>
      </b-field>

      <b-field label="Milestones" expanded>
        <table class="table is-narrow is-fullwidth">
        <tbody>
        <tr v-for="(milestone, index) in milestoneList" :key="index">
          <td>{{ milestone }}</td>
          <td>
            <b-switch
              v-model="selectedMilestones[milestone]"
              type="is-success"
              true-value="required"
              false-value="optional">
              {{ selectedMilestones[milestone] }}
            </b-switch>
            <!--
            <b-select placeholder="do you want to capture this milestone?" v-model="selectedMilestones[milestone]">
              <option value="required">Yes</option>
              <option value="optional">No</option>
              <option value="no required">Up to the carrier</option>
            </b-select>
            -->
          </td>
        </tr>
        </tbody>
      </table>
      </b-field>
    </b-field>

  </form>
</template>

<script>
import { isEmpty, isEqual } from 'lodash-es'
import DocumentUploader from '@/components/DocumentUploader'
import DocumentLibrary from '@/components/CompanyDocumentsTable/index'

import milestones from '@/lookup-data/milestones'
export default {
  name: 'BasicInformation',

  components: { DocumentUploader, DocumentLibrary },

  created() {
    this._preSetMilestones()
    this.copyModelValue()
  },

  props: {
    companyJobKey: {
      type: String
    },
    value: {
      type: Object
    }
  },

  data() {
    return {
      rate: null,
      companyJobId: null,
      selectedMilestones: {},
      milestoneList: milestones,
      documents: []
    }
  },

  methods: {
    updateAttachedList() {
      window.setTimeout(() => {
        this.$refs['attachedDocuments'].silentFetch()
      }, 500)
    },

    /**
     * Pre-sets the milestones object from the external list
     */
    _preSetMilestones() {
      milestones.forEach((milestone) => {
        this.$set(this.selectedMilestones, milestone, 'required')
      })
    },

    /**
     * Takes any value passed in via the `value` prop (aka: v-model fro the parent) and assigns it to local properties
     */
    copyModelValue() {
      if (this.rate !== this.value.rate) {
        this.rate = this.value.rate || 0
      }

      if (!isEmpty(this.value.milestones) && !isEqual(this.selectedMilestones, this.value.milestones)) {
        this.selectedMilestones = Object.assign({}, this.value.milestones)
      }

      if (!isEmpty(this.value.documents) && !isEqual(this.documents, this.value.documents)) {
        this.documents = [...this.value.documents]
      }

      this.companyJobId = this.value.companyJobId
    },

    notify() {
      if (
        this.rate !== this.value.rate ||
        !isEqual(this.selectedMilestones, this.value.milestones) ||
        !isEqual(this.documents, this.value.documents)
      ) {
        this.$emit('input', {
          rate: this.rate,
          milestones: this.selectedMilestones,
          documents: this.documents,
          companyJobId: this.companyJobId
        })
      }
    }
  },

  watch: {
    value: {
      deep: true,
      handler: 'copyModelValue'
    },
    rate: 'notify',
    documents: 'notify',
    selectedMilestones: {
      deep: true,
      handler: 'notify'
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  text-transform: capitalize;
}

.attached-documents {
  // same height as the "milestones" table
  height: 295px;
  overflow: auto;
}

.field-section {
  margin-bottom: 50px;
}
</style>
